import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import {
  BlockTypes,
  ImageBlockAlignment,
  ImageBlockData,
  ImageBlockSize,
} from '../../../../models';
import { ImageNodeView } from './ImageNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    imageNode: {
      insertImageNode: ({
        items,
        withBorder,
        withBackground,
        stretched,
      }: ImageBlockData) => ReturnType;
    };
  }
}

export const ImageNode = Node.create({
  name: 'imageNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      items: [],
      pastedFiles: [],
      withBorder: false,
      withBackground: false,
      stretched: false,
      alignment: { default: ImageBlockAlignment.FULL },
      size: { default: ImageBlockSize.MEDIUM },
    };
  },

  parseHTML() {
    return [{ tag: BlockTypes.image }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.image, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertImageNode:
        ({ items, withBackground, withBorder, stretched }: ImageBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({
            type: this.name,
            attrs: { items, withBackground, withBorder, stretched },
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageNodeView);
  },
});
